// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as DownloadAppsBanner__Blocks$PrezzeeRibbon from "./DownloadAppsBanner__Blocks.bs.js";
import * as DownloadAppsBanner__Heading$PrezzeeRibbon from "./DownloadAppsBanner__Heading.bs.js";
import * as DownloadAppsBanner__AppBadges$PrezzeeRibbon from "./DownloadAppsBanner__AppBadges.bs.js";
import * as DownloadAppsBanner__Container$PrezzeeRibbon from "./DownloadAppsBanner__Container.bs.js";
import * as DownloadAppsBanner__SubHeading$PrezzeeRibbon from "./DownloadAppsBanner__SubHeading.bs.js";

function DownloadAppsBanner(props) {
  return JsxRuntime.jsxs(DownloadAppsBanner__Container$PrezzeeRibbon.make, {
              children: [
                JsxRuntime.jsx(DownloadAppsBanner__Heading$PrezzeeRibbon.make, {
                      children: props.heading
                    }),
                JsxRuntime.jsx(DownloadAppsBanner__SubHeading$PrezzeeRibbon.make, {
                      children: props.description
                    }),
                JsxRuntime.jsx(DownloadAppsBanner__Blocks$PrezzeeRibbon.make, {
                      children: props.blocks
                    }),
                JsxRuntime.jsx(DownloadAppsBanner__AppBadges$PrezzeeRibbon.make, {
                      children: props.badges
                    })
              ],
              background: props.background,
              mobileBackground: props.mobileBackground
            });
}

var Container;

var Heading;

var SubHeading;

var Blocks;

var AppBadges;

var make = DownloadAppsBanner;

export {
  Container ,
  Heading ,
  SubHeading ,
  Blocks ,
  AppBadges ,
  make ,
}
/* react/jsx-runtime Not a pure module */
